export const Spinner = ({ isLoading }) => {
  return isLoading ? <div className="spinner"></div> : null;
};
